import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  text-align: left;
  width: 100%;

  h5 {
    margin-top: 28px;
    margin-bottom: 12px;
  }
`